module.exports = __webpack_public_path__ + "img/chart-icon.44bcd0fd.svg";